import React, { useRef, useState, useContext, useEffect } from "react";
import "./Modal.scss";
import ReactDOM from "react-dom";
import styled from "styled-components";

const DefaultStyle = (props) => {
  console.log("props" , props);
  console.log("props.size" , props.size);
  console.log("props.header" , props.header);
  return (
    <div style={{background: "radial-gradient(circle, #272f42 0%, #0f121a 100%)"}}
      {...props}
      className={`Modal ${
        props.centered === false ? "not-centered" : "centered"
      }`}
    >
      <div style={{background: "radial-gradient(circle, #272f42 0%, #0f121a 100%)"}}
        className={`popup-body ${props.size ? props.size : "md"}`}
        style={props.style || {}}
      >
        <div
          className="header"
          dangerouslySetInnerHTML={{ __html: props.header }}
        ></div>
        <div className="body">{props.children}</div>
        {(props.closebuttonstate==false||props.closebuttonstate==undefined)&&<div
          className="button global-button"
          dangerouslySetInnerHTML={{ __html: props.button || "Close" }}
          onClick={props.onClickClose}
        ></div>}
      </div>
    </div>
  );
};

const ModalStyles = (props) => {
  console.log("props" , props);
  console.log("props.variant" , props.variant);
  switch (props.variant) {
    case `white`:
      return <DefaultStyle {...props}>{props.children}</DefaultStyle>;
    default:
      return <ModalOverlay>{props.children}</ModalOverlay>;
  }
};

const Context = React.createContext();

export function ModalProvider({ children }) {
  const modalRef = useRef();
  const [context, setContext] = useState();

  // make sure re-render is triggered after initial
  // render so that modalRef exists
  useEffect(() => {
    setContext(modalRef.current);
  }, []);

  return (
    <>
      <Context.Provider value={context}>{children}</Context.Provider>
      <div ref={modalRef} />
    </>
  );
}

export default function Modal({ onClose, children, ...props }) {
  const modalNode = useContext(Context);

  return modalNode
    ? ReactDOM.createPortal(
        <ModalStyles {...props}>{children}</ModalStyles>,
        modalNode
      )
    : null;
}

const ModalContainer = styled.div`
// position: absolute;
// top: 0;
// left: 0;
`;

const ModalOverlay = styled.div`
animation: kOCoaO 200ms ease-out;
position: absolute;
top: 0;
left: 0;
width: 100vw;
height: 100vh;
background: rgba(0,0,0,0.3);
`